import React from "react";

const Footer = () => {
  return <div className="py-4 text-center bg-primary text-white "> &copy; 2023 AbiySamson all right reserved</div>;
};

export default Footer;